<wl-busy [show]="loading.busy"></wl-busy>
<select *ngIf="!loading.busy" [(ngModel)]="value" class="form-control" (blur)="onBlur()" (ngModelChange)="modelChange($event)">
  <option *ngIf="includeNoneValue" value="0">{{ _noneText ? _noneText : ('common.none' | translate | titlecase) }}</option>
  <option *ngFor="let revenueItem of revenueItems" [value]="revenueItem.ItemNum" [selected]="revenueItem.ItemNum == value ? true : null">
    {{ revenueItem.ItemName }}
  </option>
</select>
